import React, { useCallback, useEffect, useState } from 'react';
//eslint-disable-next-line no-restricted-imports
import { Tooltip as MuiTooltip, Fade, TooltipProps } from '@mui/material';

export interface Props extends TooltipProps {
  transitionTimeout?: number | { appear?: number; enter?: number; exit?: number };
  testID?: string;
  allowScroll?: boolean;
  shouldOpen?: () => boolean;
}

const Tooltip = ({
  children,
  enterDelay = 500,
  enterTouchDelay = 700,
  transitionTimeout = 500,
  placement = 'top',
  testID,
  allowScroll,
  shouldOpen,
  ...props
}: Props) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(!shouldOpen || shouldOpen());
  };

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    if (!open || allowScroll) return;

    window.addEventListener('scroll', handleClose, true);
    return () => window.removeEventListener('scroll', handleClose, true);
  }, [open, allowScroll]);

  return (
    <MuiTooltip
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      enterDelay={enterDelay}
      slots={{ transition: Fade }}
      slotProps={{ transition: { timeout: transitionTimeout } }}
      leaveTouchDelay={3000}
      enterTouchDelay={enterTouchDelay}
      placement={placement}
      {...(testID && { 'data-test-id': testID })}
      {...props}
    >
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
